(function(){
  var D=[[380,0],[390,0],[400,0],[410,0.18],[420,0.57],[430,0.59],[440,0.30],[450,0.13],
         [460,0.37],[470,0.47],[480,0.29],[490,0.27],[500,0.27],[510,0.19],[520,0.19],
         [530,0.33],[540,0.62],[550,0.54],[560,0.88],[570,4.45],[580,16.65],[590,35.73],
         [600,58.17],[610,75.44],[620,85.81],[630,89.26],[640,89.46],[650,90.60],[660,92.83],
         [670,93.46],[680,93.02],[690,92.68],[700,93.55],[710,94.71],[720,93.76],[730,89.81],
         [740,90.97],[750,93.75],[760,95.01],[770,95.05],[780,93.88]];

  var L=64,R=795,T=18,B=292,W0=380,W1=780;
  function X(w){return L+(w-W0)/(W1-W0)*(R-L)}
  function Y(t){return B-t/100*(B-T)}
  var NS='http://www.w3.org/2000/svg';

  function boot(){
    var root=document.getElementById('slpChart');
    if(!root||root.getAttribute('data-ready'))return;
    var svg=root.querySelector('svg');
    if(!svg)return;
    root.setAttribute('data-ready','1');

    var grid=svg.querySelector('#slpGrid'), axis=svg.querySelector('#slpAxis');
    [0,25,50,75,100].forEach(function(t){
      var ln=document.createElementNS(NS,'line');
      ln.setAttribute('x1',L);ln.setAttribute('x2',R);
      ln.setAttribute('y1',Y(t));ln.setAttribute('y2',Y(t));
      ln.setAttribute('stroke','#F5F1EA');ln.setAttribute('stroke-opacity',t===0?'.22':'.09');
      ln.setAttribute('stroke-width','1');
      grid.appendChild(ln);
      var tx=document.createElementNS(NS,'text');
      tx.setAttribute('x',L-11);tx.setAttribute('y',Y(t)+3.5);
      tx.setAttribute('text-anchor','end');tx.setAttribute('font-size','10.5');
      tx.setAttribute('fill','#F5F1EA');tx.setAttribute('fill-opacity','.45');
      tx.textContent=t+' %';
      axis.appendChild(tx);
    });
    [400,450,500,550,600,650,700,750].forEach(function(w){
      var tx=document.createElementNS(NS,'text');
      tx.setAttribute('x',X(w));tx.setAttribute('y',B+20);
      tx.setAttribute('text-anchor','middle');tx.setAttribute('font-size','10.5');
      tx.setAttribute('fill','#F5F1EA');tx.setAttribute('fill-opacity','.45');
      tx.textContent=w;
      axis.appendChild(tx);
    });
    var xl=document.createElementNS(NS,'text');
    xl.setAttribute('x',(L+R)/2);xl.setAttribute('y',B+55);
    xl.setAttribute('text-anchor','middle');xl.setAttribute('font-size','10');
    xl.setAttribute('fill','#F5F1EA');xl.setAttribute('fill-opacity','.38');
    xl.setAttribute('letter-spacing','.12em');
    xl.textContent=root.getAttribute('data-xlabel')||'BØLGELENGDE (NM)';
    axis.appendChild(xl);

    var bb=svg.querySelector('#slpBlueBand');
    bb.setAttribute('x',X(380));bb.setAttribute('y',T);
    bb.setAttribute('width',X(500)-X(380));bb.setAttribute('height',B-T);

    var sb=svg.querySelector('#slpSpecBar');
    sb.setAttribute('x',L);sb.setAttribute('y',B+28);
    sb.setAttribute('width',R-L);sb.setAttribute('height',5);

    var d='',i;
    for(i=0;i<D.length;i++){d+=(i?' L':'M')+X(D[i][0]).toFixed(2)+' '+Y(D[i][1]).toFixed(2)}
    svg.querySelector('#slpLine').setAttribute('d',d);
    svg.querySelector('#slpArea').setAttribute('d',d+' L'+X(W1).toFixed(2)+' '+B+' L'+X(W0).toFixed(2)+' '+B+' Z');

    var hit=svg.querySelector('#slpHit');
    hit.setAttribute('x',L);hit.setAttribute('y',T);
    hit.setAttribute('width',R-L);hit.setAttribute('height',B-T+30);

    var cur=svg.querySelector('#slpCursor'),
        cl=svg.querySelector('#slpCursorLine'),
        cd=svg.querySelector('#slpCursorDot'),
        rd=root.querySelector('#slpRead'),
        rw=rd.querySelector('.slp-chart__readwl'),
        rt=rd.querySelector('.slp-chart__readt');

    var TAIL=rt.getAttribute('data-tail')||' – praktisk talt alt stoppes';
    function fmt(n){return n.toFixed(2).replace('.',',')}
    function show(wl){
      var best=D[0],bd=1e9;
      for(var j=0;j<D.length;j++){var dd=Math.abs(D[j][0]-wl);if(dd<bd){bd=dd;best=D[j]}}
      var x=X(best[0]),y=Y(best[1]);
      cl.setAttribute('x1',x);cl.setAttribute('x2',x);
      cl.setAttribute('y1',T);cl.setAttribute('y2',B);
      cd.setAttribute('cx',x);cd.setAttribute('cy',y);
      cur.style.opacity='1';
      rw.textContent=best[0]+' nm';
      rt.textContent=fmt(best[1])+' % slipper gjennom'+(best[1]<1?TAIL:'');
    }
    function pos(ev){
      var r=svg.getBoundingClientRect();
      var cx=(ev.touches&&ev.touches[0]?ev.touches[0].clientX:ev.clientX);
      var vx=(cx-r.left)/r.width*820;
      var wl=W0+(vx-L)/(R-L)*(W1-W0);
      if(wl<W0)wl=W0; if(wl>W1)wl=W1;
      show(wl);
    }
    hit.addEventListener('mousemove',pos);
    hit.addEventListener('touchstart',function(e){pos(e)},{passive:true});
    hit.addEventListener('touchmove',function(e){pos(e)},{passive:true});
    hit.addEventListener('mouseleave',function(){cur.style.opacity='0';show(450)});
    show(450);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot);
  }else{ boot(); }
  window.addEventListener('load',boot);
  document.addEventListener('shopify:section:load',boot);
})();